module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo2-242f461ad415b09e24c161a56bdcb5c4.png";